export default __webpack_public_path__ + "static/media/batteryLogo.003a5c36.svg";